import React, { useState } from 'react';
import { Modal } from './Modal';
import { MessageSquare, ThumbsUp, Lightbulb, AlertCircle } from 'lucide-react';
import { useToast } from '../../context/ToastContext';
interface FeedbackModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function FeedbackModal({
  isOpen,
  onClose
}: FeedbackModalProps) {
  const [selectedEmployee, setSelectedEmployee] = useState('');
  const [feedbackType, setFeedbackType] = useState<'positive' | 'constructive' | 'suggestion' | ''>('');
  const [message, setMessage] = useState('');
  const {
    showToast
  } = useToast();
  const employees = [{
    id: '1',
    name: 'Marie Dupont'
  }, {
    id: '2',
    name: 'Thomas Petit'
  }, {
    id: '3',
    name: 'Sophie Bernard'
  }, {
    id: '4',
    name: 'Camille Roux'
  }];
  const feedbackTypes = [{
    value: 'positive',
    label: 'Positif',
    icon: ThumbsUp,
    color: 'green',
    description: 'Féliciter et encourager'
  }, {
    value: 'constructive',
    label: 'Constructif',
    icon: AlertCircle,
    color: 'amber',
    description: 'Suggérer des améliorations'
  }, {
    value: 'suggestion',
    label: 'Suggestion',
    icon: Lightbulb,
    color: 'blue',
    description: 'Proposer une idée'
  }];
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!selectedEmployee || !feedbackType || !message) {
      showToast('Veuillez remplir tous les champs', 'error');
      return;
    }
    const employeeName = employees.find(e => e.id === selectedEmployee)?.name;
    showToast(`Feedback envoyé à ${employeeName}`, 'success');
    setSelectedEmployee('');
    setFeedbackType('');
    setMessage('');
    onClose();
  };
  return <Modal isOpen={isOpen} onClose={onClose} title="Donner du feedback" size="lg" data-id="element-1799">
      <form onSubmit={handleSubmit} className="space-y-6" data-id="element-1800">
        <div data-id="element-1801">
          <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1802">
            Sélectionner un employé
          </label>
          <select value={selectedEmployee} onChange={e => setSelectedEmployee(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" required data-id="element-1803">
            <option value="" data-id="element-1804">Choisir un employé...</option>
            {employees.map(employee => <option key={employee.id} value={employee.id} data-id="element-1805">
                {employee.name}
              </option>)}
          </select>
        </div>
        <div data-id="element-1806">
          <label className="block text-sm font-medium text-gray-700 mb-3" data-id="element-1807">
            Type de feedback
          </label>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3" data-id="element-1808">
            {feedbackTypes.map(type => {
            const Icon = type.icon;
            return <button key={type.value} type="button" onClick={() => setFeedbackType(type.value as any)} className={`p-4 border-2 rounded-lg text-left transition-all ${feedbackType === type.value ? `border-${type.color}-500 bg-${type.color}-50` : 'border-gray-200 hover:border-gray-300'}`} data-id="element-1809">
                  <div className="flex items-center mb-2" data-id="element-1810">
                    <Icon className={`h-5 w-5 text-${type.color}-600 mr-2`} data-id="element-1811" />
                    <span className="font-medium text-gray-900" data-id="element-1812">
                      {type.label}
                    </span>
                  </div>
                  <p className="text-xs text-gray-600" data-id="element-1813">{type.description}</p>
                </button>;
          })}
          </div>
        </div>
        <div data-id="element-1814">
          <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1815">
            Votre message
          </label>
          <textarea value={message} onChange={e => setMessage(e.target.value)} rows={6} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Partagez votre feedback de manière constructive et spécifique..." required data-id="element-1816" />
          <p className="text-xs text-gray-500 mt-1" data-id="element-1817">
            Conseil: Soyez spécifique et donnez des exemples concrets
          </p>
        </div>
        <div className="flex justify-end space-x-3 pt-4 border-t" data-id="element-1818">
          <button type="button" onClick={onClose} className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-1819">
            Annuler
          </button>
          <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded-md text-sm font-medium hover:bg-blue-700" data-id="element-1820">
            Envoyer le feedback
          </button>
        </div>
      </form>
    </Modal>;
}